import React, {useState, useEffect} from "react";
import { Link, useNavigate, useParams } from 'react-router-dom'
import axios from "axios";
import { $ } from "react-jquery-plugin";
import { decode } from "html-entities"; 
import { FallingLines } from 'react-loader-spinner'
import { associationNewOfficials } from "../../../apis/urls";


const AssociationDashboard = () => {


    useEffect( ()=> {
        $('body').removeClass('sidebar-collapsed sidebar-active').addClass('');
        ApproveListing();
    },[])

    let navigate = useNavigate()


    let role = localStorage.getItem('userrole');

    // console.log("role", role)




    const [result, setResult] = useState([]); 
    const [resultAss, setResultAss] = useState(); 
    const [loader, setLoader] = useState(true);  
  
    const {id} = useParams();

    let token = "Bearer "+localStorage.getItem('token');

    const ApproveListing = () => {
         
        const instance = axios.create({

            baseURL: associationNewOfficials+"/"+id,

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.get('').then((response) =>{
            
            setResult(response.data.data[0].officials);
            setLoader(false)
            setResultAss(response.data.data[0])

            console.log(response.data.data[0])
          }).catch((error) =>{

            
            // localStorage.removeItem('token')
    
            // navigate("/")

            console.log('error',error.message)
            
          });

    }


    let sl=1;

    let newarr =0;
    let uparr =0;
    let inarr =0;
    let apparr =0;

    return( 
        <div className="dashboard">
            <aside class="right-side areas">
                <div class="content-area dash-contentss">
                <div>

                    <div class="page-title-wrpr">
                        <div class="page-title-left-column">
                            <h2 class="page-title"> Dashboard - New Officials  </h2>
                        </div>
                    </div>


                    {!loader?

                        <div class="container">


                            <table class="table table-rules">
                                <thead>
                                    <tr className="rules-table-head">
                                        <th scope="col">Sl.No</th>
                                        <th scope="col">Official Name</th>
                                        <th scope="col">Email</th>
                                        <th scope="col">Phone</th>
                                        <th scope="col">Payment Status</th>
                                        <th scope="col" style={{textAlign:'center'}}>Actions</th>
                                    </tr>
                                </thead>
                                <tbody className="rules-table-content">
                                {
									result?.map((item,index) =>(

                                        <tr >
                                            <td>{sl++}</td>
											<td>{decode(item.firstname +" "+ item.lastname)}</td>
                                            <td>
                                                <Link  to={"/officialview/"+id+"/"+item.id} style={{color:'#000'}} >
                                                    {item.createdCount=== 0?<button disabled style={{background:'transparent'}}>0</button>:item.email}
                                                </Link>
                                            </td>
                                            <td>
                                                <Link  to={"/officialview/"+id+"/"+item.id} style={{color:'#000'}} >
                                                    {item.updatedCount=== 0?<button disabled style={{background:'transparent'}}>0</button>:item.work_phone}
                                                </Link>
                                            </td>

                                            <td>
                                                <Link  to={"/officialview/"+id+"/"+item.id} style={{color:'#000'}}>
                                                    {item.inligibleCount=== 0?<button disabled style={{background:'transparent'}}>0</button>:item.payment_status}
                                                </Link>
                                            </td>
                                            <td>
                                                <div className="list-action-wrpr showicons roundicons-text">
                                                    <div className="list-action-wrpr">
                                                        <Link  to={"/officialview/"+id+"/"+item.id} data-toggle="tooltip" title="View">
                                                            <i class="view icon-eye"></i>
                                                            <span>View</span>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </td>
                                        
                                        </tr>
                                    ))
                                }
                                
                                </tbody>
                            </table>
                        </div>:

                        
                    <div class="container" style={{alignItems:'center', marginLeft:'45%', marginTop:'20%'}}>
                    <div className="fp-container">
                        <FallingLines
                            color="#fff"
                            width="50"
                            visible={true}
                            ariaLabel='falling-lines-loading'
                            />
                    </div>
                    </div>

                    }            

                    </div>
                </div>
            </aside>
        </div>
    )
};

export default AssociationDashboard;
